/**
 * Lightweight event emitter for session expiration.
 * Uses a DOM CustomEvent so both React components and plain functions
 * (like `requestByToken`) can trigger / listen without React context.
 */

const EVENT_NAME = "session-expired";

let fired = false;

export const emitSessionExpired = () => {
  if (fired) return;
  fired = true;
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
};

export const onSessionExpired = (callback: () => void) => {
  window.addEventListener(EVENT_NAME, callback);
  return () => window.removeEventListener(EVENT_NAME, callback);
};

export const resetSessionExpired = () => {
  fired = false;
};
